// @ts-nocheck
import { CheckCircleIcon } from '@heroicons/react/20/solid';
import { UserGroupIcon } from '@heroicons/react/24/outline';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useFetchAdmin } from '../../components/hooks/fetchName';
import { URL } from '../../service/Service';
import { useTranslation } from '../../i18n/LanguageContext';

export function Dashboard() {
  const { t } = useTranslation();
  const partnerName = useFetchAdmin();
  const [currentHour] = useState(new Date().getHours());
  const [numberOfPartners, setNumberOfPartners] = useState(0); // State to hold the number of partners

  let greeting;

  const includedFeatures = [
    t('dashboard.createPartners'),
    t('dashboard.createRates'),
    t('dashboard.confirmWithdrawals'),
    t('dashboard.liveTransactions'),
  ];
  const jwtToken = sessionStorage.getItem('jwt');

  useEffect(() => {
    // Fetch the number of partners when the component mounts
    axios
      .get(`${URL}/api/partners/size`, {
        headers: {
          'Authorization': `Bearer ${jwtToken}`,
          'Content-Type': 'application/json'
        }
      })
      .then(response => {
        setNumberOfPartners(response.data); // Update the state with the number of partners
      })
      .catch(error => {
        console.log(error);
      });
  }, [jwtToken]);

  if (currentHour >= 0 && currentHour < 12) {
    greeting = t('dashboard.morning');
  } else if (currentHour >= 12 && currentHour < 18) {
    greeting = t('dashboard.afternoon');
  } else {
    greeting = t('dashboard.evening');
  }

  return (
    <main className="dashboard-shell">
      <div className="dashboard-layout">
        <section className="dashboard-welcome grid gap-8 p-6 sm:p-9 lg:grid-cols-[1fr_330px] lg:p-10">
          <div className="flex flex-col justify-center">
            <span className="dashboard-kicker">Backoffice Eupago</span>
            <h1 className="mt-5 max-w-3xl text-4xl font-extrabold tracking-tight text-gray-900 sm:text-5xl">
              {greeting}, <span className="font-medium">{partnerName.name}!</span>
            </h1>
            <h2 className="mt-3 text-lg font-semibold text-gray-600 sm:text-xl">{t('dashboard.subtitle')}</h2>

            <div className="mt-8">
              <h3 className="text-xs font-extrabold uppercase tracking-[0.17em] text-green-cl">{t('dashboard.included')}</h3>
              <ul className="mt-4 grid gap-3 sm:grid-cols-2">
                {includedFeatures.map((feature) => (
                  <li key={feature} className="dashboard-feature">
                    <span className="dashboard-feature-icon"><CheckCircleIcon className="h-5 w-5" aria-hidden="true" /></span>
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="dashboard-stat-card">
            <span className="dashboard-stat-icon">
              <UserGroupIcon className="h-10 w-10" />
            </span>
            <p className="mt-6 text-sm font-semibold text-gray-500">{t('dashboard.partnerCount')}</p>
            <strong className="mt-1 text-5xl font-extrabold tracking-tight text-gray-900">{numberOfPartners}</strong>
            <a
              href={numberOfPartners === 0 ? "/admin/criar-parceiro" : "/admin/parceiros"}
              className="ui-button-primary mt-6 w-full"
            >
              {numberOfPartners === 0 ? t('dashboard.firstPartner') : t('dashboard.allPartners')}
            </a>
          </div>
        </section>
      </div>
    </main>
  );
}

export default Dashboard;
